<template>
  <v-container>
    <!--------------this page title----------->
    <page-title title="notification" />

    <!--TODO: ---------- make truncated show on click- also give new  notification color and cached the viewed ones------------>
    <v-list three-line>
      <v-list-item-group active-class="pink--text">
        <template v-for="(notification, index) in notifications">
          <v-list-item :key="index">
            <v-list-item-content>
              <!-- ---------notification title containing title and the time the notification was created----- -->
              <v-list-item-title class="d-flex justify-space-between"
                ><span class="h2 text-capitalize">{{
                  notification.title
                }}</span>
                <time-ago :datetime="notification.date" :refresh="60" long />
              </v-list-item-title>

              <!-- ---------notification detail containing details of the  notification was ---- -->
              <v-list-item-subtitle
                v-text="notification.body"
              ></v-list-item-subtitle>
            </v-list-item-content>

            <!----on click of each mutate the global notification count, reducing by one----------->
            <v-list-item-action>
              <v-list-item-action-text> </v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>
          <v-divider
            v-if="index < notifications.length - 1"
            :key="index"
            class="my-3"
          ></v-divider>
        </template>
      </v-list-item-group>
    </v-list>
  </v-container>
</template>

<script>
// for keeping track of time
import { TimeAgo } from "vue2-timeago";
import "vue2-timeago/dist/vue2-timeago.css";

//import central store for the sake of notification
import store from "@/store";
import PageTitle from "../../components/PageTitle.vue";

//import notification from central store
export default {
  components: {
    TimeAgo,
    PageTitle,
  },
  data: () => ({}),
  computed: {
    //load notification from central store when user is authenticated
    notifications: () => store.getters["notification/data"],
  },
};
</script>